// The link to the server: other players, the townspeople, chat and questions
// about the town. The game keeps working alone if the server cannot be reached.
export class Net {
  constructor() {
    this.ws = null;
    this.online = false;
    this.id = 0;
    this.handlers = {};
    this.retry = 1000;
    this.hello = null;
  }

  on(type, fn) {
    this.handlers[type] = fn;
  }

  // name, look: what the server tells other players about us. token: the
  // private key, kept in this browser, that marks which plots are ours.
  // region: which region's town we are in.
  connect(name, look, token, region, origin = null) {
    this.hello = { t: 'hello', name, look, token, region, origin };
    this.open();
  }

  open() {
    const scheme = location.protocol === 'https:' ? 'wss' : 'ws';
    let ws;
    try {
      ws = new WebSocket(`${scheme}://${location.host}/play`);
    } catch {
      this.schedule();
      return;
    }
    this.ws = ws;
    ws.onopen = () => {
      this.online = true;
      this.retry = 1000;
      this.send(this.hello);
    };
    ws.onmessage = (e) => {
      let m;
      try {
        m = JSON.parse(e.data);
      } catch {
        return;
      }
      if (m.t === 'welcome') this.id = m.id;
      const fn = this.handlers[m.t];
      if (fn) fn(m);
    };
    ws.onclose = () => {
      const was = this.online;
      this.online = false;
      if (was && this.handlers.offline) this.handlers.offline();
      this.schedule();
    };
    ws.onerror = () => ws.close();
  }

  schedule() {
    setTimeout(() => this.open(), this.retry);
    this.retry = Math.min(15000, this.retry * 1.7);
  }

  send(msg) {
    if (this.ws && this.ws.readyState === 1) this.ws.send(JSON.stringify(msg));
  }
}
